import { useCheckQrToken } from '@/hooks/useCheckQrToken'
import { useGenerateAuthQrToken } from '@/hooks/useGenerateAuthQrToken'
import { useAuth } from '@context/AuthContext'
import { useQueryClient } from '@tanstack/react-query'
import React, { useEffect } from 'react'
import GoogleLoginButton from '../../components/Auth/GoogleLoginButton'
import { trackEvent } from '../../lib/analytics'
import {
	Card,
	Container,
	Divider,
	LoadingSpinner,
	QrCodeImage,
	QrCodeWrapper,
	QrContainer,
	QrInstruction,
	QrSection,
	QrTitle,
	Subtitle,
	Title,
} from './styles'

const LoginPage: React.FC = () => {
	const { setAuth } = useAuth()
	const queryClient = useQueryClient()
	const { data: authQrTokenData, isLoading } = useGenerateAuthQrToken()
	const { data: qrCheckData } = useCheckQrToken(authQrTokenData?.token, !isLoading)

	useEffect(() => {
		if (qrCheckData?.user) {
			// User has authenticated via QR code
			setAuth({ token: qrCheckData.token, user: qrCheckData.user })
			trackEvent('login_success', { method: 'qr' })
			// Reset the query data to prevent auto-login after logout
			queryClient.resetQueries({ queryKey: ['qr-token-check'] })
		}
	}, [qrCheckData, setAuth, queryClient])

	return (
		<Container>
			<Card>
				<Title>Welcome to Orbit</Title>
				<Subtitle>Sign in to access your itinerary planner</Subtitle>
				<GoogleLoginButton />

				<Divider>Or</Divider>

				<QrSection>
					<QrTitle>Scan QR code to sign in</QrTitle>
					<QrContainer>
						{isLoading || !authQrTokenData?.token ? (
							<LoadingSpinner />
						) : (
							<QrCodeWrapper>
								<QrCodeImage
									size={200}
									value={`https://orbitnow.app/appLink/qr-auth/${authQrTokenData.token}`}
									viewBox={`0 0 200 200`}
								/>
							</QrCodeWrapper>
						)}
					</QrContainer>
					<QrInstruction>
						Open your camera on your phone and scan this QR code to sign in instantly. You must be
						logged into the Orbit mobile app.
					</QrInstruction>
				</QrSection>
			</Card>
		</Container>
	)
}

export default LoginPage
